document.addEventListener("DOMContentLoaded", () => {
    const successPage = document.querySelector(".page-template-success");
    if (!successPage) return false;

    const urlParams = new URLSearchParams(window.location.search);
    const isHH = urlParams.get("hh");
    if (!isHH) return false;

    document.body.classList.add("hoeren-heute");

    const heroBg = document.querySelector(".hero__background");
    const heroBgSource = heroBg.querySelector("source");
    const heroBgImg = heroBg.querySelector("img");
    const bgDesktop = heroBg.dataset.hhDesktop;
    const bgMobile = heroBg.dataset.hhMobile;

    heroBgSource.srcset = bgDesktop;
    heroBgImg.src = bgMobile;
});
